// src/utils/chatbot.js

export const faqList = [
  {
    question: "How do I book an appointment with a solicitor?",
    answer:
      "You can search for solicitors using location and practice area, view their profile, and click on the “Book Appointment” button to schedule a consultation online."
  },
  {
    question: "Can I book an appointment for a future date?",
    answer:
      "Yes, you can book appointments only for future available time slots. Past time slots are disabled for booking."
  },
  {
    question: "How are solicitors verified on Justivon?",
    answer:
      "All solicitors go through a verification process where their identity, credentials, and practice details are reviewed by the Justivon admin team."
  },
  {
    question: "Can I view a solicitor’s experience and practice areas?",
    answer:
      "Yes, each solicitor profile displays their experience, advocate level, courts practiced, and detailed practice areas."
  },
  {
    question: "Do I need an account to use Justivon?",
    answer:
      "Yes, creating an account is required to book appointments, manage cases, and track your consultations."
  },
  {
    question: "How can I view my appointment history?",
    answer:
      "Log in to your dashboard and go to the Appointments section to see your past and upcoming consultations."
  },
  {
    question: "Can I manage my legal cases online?",
    answer:
      "Yes, Justivon provides a case management system where you can view case status, hearing dates, and updates in calendar mode."
  },
  {
    question: "Is my consultation information confidential?",
    answer:
      "Yes, all consultations and messages are treated as strictly confidential and are visible only to you and your solicitor."
  }
];

export const defaultQuestions = [
  "How do I book an appointment with a solicitor?",
  "Can I cancel or reschedule my appointment?",
  "How are solicitors verified on Justivon?",
  "Is my consultation information confidential?"
];

const greetingWords = [
  "hi",
  "hello",
  "hey",
  "good morning",
  "good afternoon",
  "good evening"
];

export const isGreeting = (text) => {
  const msg = text.toLowerCase();
  return greetingWords.some((g) => msg.includes(g));
};

export const findFaqAnswer = (userText) => {
  const normalized = userText.toLowerCase();

  return faqList.find((faq) =>
    faq.question.toLowerCase().includes(normalized)
  );
};

export const getBotReply = (userText) => {
  if (isGreeting(userText)) {
    return "Hello 👋 Welcome to Justivon. You can ask me about appointments, solicitors and case management.";
  }

  const matched = findFaqAnswer(userText);

  if (matched) {
    return matched.answer;
  }

  return "Sorry, I couldn’t find an exact answer. Please ask about appointments, solicitors or case management.";
};
